import { CartItem } from '../../../../../core';
  export const servicesAdditional = {
    columns: [
      {
        title: 'SKU',
        name: 'skuCode',
        type: 'string',
        class: 'left',
        value: (element: CartItem) => element.skuCode
      },
      {
        title: 'Descripción',
        name: 'description',
        type: 'string',
        class: 'left',
        value: (element: CartItem) => element.description
      },
      {
        title: 'Cantidad',
        name: 'quantity',
        type: 'string',
        editable: true,
        class: 'center w120',
        value: (element: CartItem) => element.quantity
      },
      {
        title: 'Precio',
        name: 'price',
        type: 'string',
        class: 'right',
        value: (element: CartItem) => 'S/' + Number(element.price).toFixed(2)
      },
    ]
  };
